/*  MUI  */
import { Box, Typography } from '@mui/material';

/* Shared */
import { FontSizes } from 'application/Shared/Constants';

/*  Objects  */
import { Activity, ActivityIcon } from 'objects/Activity';

/*  React  */
import React from 'react';
import { withTranslation } from 'react-i18next';

const TranslateText = withTranslation()(({ style, text, t }) => (
    <Typography variant="p" style={{ ...style }}>
        {t(text)}
    </Typography>
));

const filters = [
    {
        children: [
            {
                default: false,
                key: 'QUICK_SCAN_LOGIN',
                name: 'Common.browser_history'
            },
            {
                default: false,
                key: 'BROWSER_LOGIN',
                name: 'Common.browser_login'
            },
            { default: false, key: 'DOWNLOAD', name: 'Common.download' },
            { default: false, key: 'LOGIN', name: 'Activity.form_login' }
        ],
        default: false,
        key: 'BROWSER',
        name: 'Common.browser'
    },
    {
        children: [
            { default: false, key: 'GOOGLE_SSO', name: 'Common.google' },
            { default: false, key: 'MICROSOFT_SSO', name: 'Common.microsoft' }
        ],
        default: false,
        key: 'SSO',
        name: 'Common.sso'
    },
    {
        children: [
            {
                default: false,
                key: 'GOOGLE_SIGN_IN',
                name: 'Common.google_login'
            },
            {
                default: false,
                key: 'AZURE_SIGN_IN',
                name: 'Common.microsoftEntraID.login'
            },

            {
                default: false,
                key: 'OKTA_SIGN_IN',
                name: 'Common.oktaLogin'
            }
        ],
        default: false,
        key: 'INTEGRATIONS',
        name: 'Common.integrations'
    },
    {
        children: [
            {
                key: 'ADD_LINK',
                name: 'Activity.application_add',
                parentKey: 'OTHER'
            }
        ],
        key: 'OTHER',
        name: 'Common.other'
    }
];

const parameter = 'activity';
const filterableOptions = [];

filters.forEach((f) => {
    const { key, name, children } = f;

    filterableOptions.push({
        ...f,
        children: children.map((c) => c.key),
        parameter,
        parent: true,
        render: (
            <TranslateText
                style={{ fontSize: FontSizes[1], fontWeight: 600 }}
                text={name}
            />
        ),
        value: key,
        visualOnly: true
    });

    children.forEach((c) => {
        filterableOptions.push({
            ...c,
            child: true,
            parameter,
            parentKey: key,
            render: (
                <Activity activity={c.key}>
                    <Box display="flex" alignItems="center">
                        <ActivityIcon size="small" key={`icon_${c.key}`} />
                        <TranslateText
                            key={`text_${c.key}`}
                            style={{ fontSize: FontSizes[1] }}
                            text={c.name}
                        />
                    </Box>
                </Activity>
            ),
            value: c.key
        });
    });
});

const headers = {
    filterable: true,
    filterableOptions,
    name: 'Common.action',
    searchable: true,
    sortable: true,
    sortableFieldType: 'string',
    sortableKey: 'activity',
    width: '20%'
};

export default headers;
